module.exports = __webpack_public_path__ + "static/img/know_how_3.a5cb5e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/know_how_3.png
// module id = SJbs
// module chunks = 0